import Preloader from '../modules/components/preloader';
import Header from '../modules/components/header';
import Menu from '../modules/components/menu';
import Animation from '../modules/animation/animation';
import ScrollToTop from '../modules/components/scroll-top';

import Accordion from '../modules/components/accordion';
import Notifications from '../modules/components/notifications';
import Redirection from '../modules/components/redirection';
import Logout from '../modules/components/logout';

import UserNotifications from '../modules/components/notifications/notifications';

export default function setCommonScripts () {
    new Preloader('.site-preloader', 500).then(() => new Animation);

    new Header('.site-header', 150, 'sticky');

    new Menu({
        menu: '.site-menu',
        toggle: '.site-menu-toggle',
        close: null
    });

    new ScrollToTop('.site-scroll-top', 300);

    Notifications();
    Redirection();
    Logout();

    new UserNotifications();

    // Accordion

    const accordions = document.querySelectorAll('.site-accordion');

    if (accordions && accordions.length) {
        for (let i = 0; i < accordions.length; i++) {
            new Accordion(`.site-accordion[data-accordion=accordion-${i}]`, { toggleAll: true });
        }
    }
}
